import chevronRight from './../../../../../assets/Navbar/chevronRightIcon.png'
import chevronRightLight from './../../../../../assets/Navbar/chevronRightLight.png'
import ImageComponent from '../../atoms/ImageComponent'
import LinkComponent from '../../atoms/LinkComponent'
import { FC } from 'react'
import { MenuLinkItemType } from '../../organisms/MobileNavMenus/pages/controller'
import { MenuNames } from '../../header'

type IProps = {
    links: MenuLinkItemType[],
    navigateFn: (target: MenuNames | 'buy/tools' | 'buy/resources' | 'sell/tools' | 'sell/resources' | 'sell-buy/tools' | 'sell-buy/resources') => void;
}

const MobileMenuFirstLayer: FC<IProps> = ({ links, navigateFn }) => {
    return (
        <>{links.map(eachPage => {
            switch (eachPage.type) {
                case "link": {
                    return <LinkComponent key={eachPage.label} to={eachPage.to as string}>
                        <button
                            className="w-full rounded-lg py-[10px] items-center font-semibold text-[#1a1a1a] justify-between flex"
                        >
                            <div
                                className="font-medium text-[#9b9b9b] text-[20px] leading-[36px]"
                            >
                                {eachPage.label}
                            </div>
                            <ImageComponent
                                source={chevronRightLight}
                                alt="chevron-right"
                            />
                        </button>
                    </LinkComponent>
                }

                case "navigate": {
                    return <button onClick={() => {
                        navigateFn(eachPage.target as "buy/tools" | "buy/resources" | MenuNames | "sell/tools" | "sell/resources" | "sell-buy/tools" | "sell-buy/resources")
                    }}
                        data-nav-target="mob-nav-buy__tools"
                        className="mt-[10px] w-full rounded-lg py-[10px] items-center font-semibold text-[#1a1a1a] justify-between flex mob-nav-page-change-btn"
                    >
                        <div
                            className="font-semibold text-[#1a1a1a] text-[24px] leading-[36px]"
                        >
                            {eachPage.label}
                        </div>
                        <ImageComponent
                            source={chevronRightLight}
                            alt="chevron-right"
                        />
                    </button>
                }

                default: {
                    return <></>;
                }
            }
        })}</>
    )
}

export default MobileMenuFirstLayer